import { render, staticRenderFns } from "./EModalRegistrarPagamento.vue?vue&type=template&id=586f9f1c"
import script from "./EModalRegistrarPagamento.vue?vue&type=script&lang=js"
export * from "./EModalRegistrarPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports